const ALLOWED_PARAMS = new Set([
  'toolbar',
  'breadcrumbs',
  'hidetheme',
  'appearance'
]);

export function workDriveEmbedSrc(urlString, params = null) {
  try {
    const url = new URL(urlString);
    if (!params) {
      url.searchParams.set('toolbar', 'false');
      url.searchParams.set('breadcrumbs', 'false');
      url.searchParams.set('hidetheme', 'true');
      url.searchParams.set('appearance', 'light');
    } else if (typeof params === 'object') {
      Object.entries(params).forEach(([key, value]) => {
        if (ALLOWED_PARAMS.has(key)) {
          url.searchParams.set(key, String(value));
        }
      });
    }
    return url.href;
  } catch {
    return urlString;
  }
}
